import React, { useContext, useState } from "react";

import { showMessage, UserError } from "helpers";
import { useActionFragment, useData, useHistory } from "hooks";

import { FormDialog } from "controls";
import { authContext } from "contexts";
import { gql } from "@apollo/client";

export default function ChangePasswordDialog({ onClose }) {
  const updatePassword = useActionFragment("updatePassword");
  const logout = useActionFragment("logout");
  const { deauthenticate } = useContext(authContext);
  const history = useHistory();
  const [newPassword, newPasswordSet] = useState("");
  const [newPasswordConfirm, newPasswordConfirmSet] = useState("");
  const data = useData(
    gql`
      query ChangePasswordDialog($password: String!) {
        passwordValidationError(password: $password)
      }
    `,
    { password: newPassword },
  );

  return (
    <FormDialog
      title="设置/更改密码"
      onClose={onClose}
      fields={[
        {
          label: "新密码",
          name: "newPassword",
          required: true,
          onChange: newPasswordSet,
          options: {
            type: "password",
            autoFocus: true,
            autoComplete: "new-password",
            error: data?.passwordValidationError && {
              message: data.passwordValidationError,
            },
          },
        },
        {
          label: "确认新密码",
          name: "newPasswordConfirm",
          required: true,
          onChange: newPasswordConfirmSet,
          options: {
            type: "password",
            autoComplete: "new-password",
            error:
              newPasswordConfirm && newPassword !== newPasswordConfirm
                ? { message: "两次输入的密码不一致" }
                : null,
          },
        },
      ]}
      onSubmit={async (formData) => {
        const { newPassword, newPasswordConfirm } = formData;
        if (newPassword !== newPasswordConfirm)
          throw new UserError("两次输入的密码不一致");
        await updatePassword({
          input: {
            newPassword,
          },
        });
        await logout({ input: {} });
        await deauthenticate();
        showMessage({ message: "成功设置新密码，请重新登录" });
        history.replace("/login");
      }}
    />
  );
}
